// SDK verisi kosulunda karsilastirma oncesi tip donusumu.
// CommonJS: webpack de node --test de ek yapilandirma olmadan okuyabilsin diye.

function coerce(value) {
    if (value === undefined || value === null) return undefined;
    if (typeof value === "boolean" || typeof value === "number") return value;

    const s = String(value).trim();
    if (s === "") return "";

    const lower = s.toLowerCase();
    if (lower === "true") return true;
    if (lower === "false") return false;

    if (s !== "" && !isNaN(Number(s))) return Number(s);

    return s;
}

// path icinde nokta varsa nested erisim yapar (lodash _.get davranisiyla aynı).
function resolvePath(obj, path) {
    if (obj === undefined || obj === null || typeof path !== "string") return undefined;
    return path.split(".").reduce((acc, part) => (acc === undefined || acc === null ? undefined : acc[part]), obj);
}

// sdkData kosulunu degerlendirir; anahtar yoksa veya operator tip hatasi verirse false doner (fail-closed).
function matchSdkData(triggerData, condition, operators) {
    const { key, operator, value } = condition || {};
    const actual = coerce(resolvePath(triggerData, key));
    if (actual === undefined) return false;

    const op = operators && operators[operator];
    if (typeof op !== "function") return false;

    try {
        return !!op(actual, coerce(value));
    } catch (e) {
        return false;
    }
}

module.exports = { coerce, matchSdkData };



// WEBPACK FOOTER //
// ./src/utils/triggerCoerce.js